module.exports = __webpack_public_path__ + "media/svg-new/paper-797ba473.svg";